const constants = {
  boxShadows: {
    normal:
      'rgba(0, 0, 0, 0.08) 0px 3px 10px 0px, rgba(0, 0, 0, 0.01) 0px 1px 0px 0px, rgba(0, 0, 0, 0.01) 0px 0px 5px 0px',
    selected:
      '0px 3px 10px 0px rgba(0,0,0,0.3), 0px 1px 0px 0px rgba(0,0,0,0.01), 0px 0px 5px 0px rgba(0,0,0,.01)',
    appBar: '0 0px 7px 0 rgba(0, 0, 0, 0.1)'
  },
  padding: {
    modal: 20
  }
};

export default constants;
